export const API_URL = 'https://szakest.sch.bme.hu/api'; //prod
//export const API_URL = 'http://localhost:8080/api'; //local

export const CLIENT_ID = '96735993585656651993'; //prod
//export const CLIENT_ID = '72589795409367724945'; //local

export const TOKEN_SUB = "sub";
export const TOKEN_NAME = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";
export const TOKEN_EMAIL = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
export const TOKEN_ROLES = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
export const TOKEN_IS_FRESHMAN = 'isFreshman';

export const ADMIN = 'Admin';
export const MEMBER = 'Member';

export const ALL = "";
export const NOT_A_MEMBER = 0;
export const POGANY = 2;
export const BALEK = 3;
export const FIRMA = 4;
export const OREGTAG = 5;

export const TRUE = "true";
export const FALSE = "false";

export const USER = 0;
export const ORGANISER = 1;
export const GUEST = 2;
export const TEACHER = 3;
export const PHANTOM = 4;

export const ACTIVE = "";
export const REGISTERED = 0;
export const CANCELLED = 1;
export const ASSIGNED = 2;
export const NOT_ASSIGNED = 3;

export const NULL = 0;
export const PRAESES = 1;
export const MAJORDOMUS = 2;
export const CONTRAPUNKT = 3;
export const CANTUSPRAESES = 4;
export const ETALONRESZEG = 5;
export const KONZEKVENCIA = 6;
export const PATERKRAMPAMPULI = 7;
export const FOAJTONALLO = 8;
export const FOGARATOR = 9;
export const GARATOR = 10;
export const FUCHSMAJOR = 11;
export const FUHRWERK = 12;

export const NOT_DONE = 0;
export const IN_PROGRESS = 1;
export const FINISHED = 2;
